<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g :fill="color" :stroke="color" class="fill-current stroke-current">
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="1.3913"
        d="M31.304 16c0 8.452-6.852 15.304-15.304 15.304s-15.304-6.852-15.304-15.304c0-8.452 6.852-15.304 15.304-15.304s15.304 6.852 15.304 15.304z"
      />
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="1.3913"
        d="M7.93 10.157h16"
      />
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="1.3913"
        d="M7.93 15.722h16"
      />
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="1.3913"
        d="M7.93 21.287h16"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
